import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { userTypeKeyToLabel } from "../../../utils/transformer";

const AccountSettingForm = ({ user, updateUserForm }) => {
  const [isEditing, setIsEditing] = React.useState(false);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        id: user ? user.id : "",
        lastName: user ? user.lastName : "",
        firstName: user ? user.firstName : "",
        type: user ? user.type : "",
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);
          updateUserForm(values);
          setIsEditing(false);
        }, 500);
      }}
      validationSchema={Yup.object().shape({
        id: Yup.string(),
        lastName: Yup.string().required("Champ Requis"),
        firstName: Yup.string().required("Champ Requis"),
        type: Yup.string(),
      })}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
        } = props;

        return (
          <form onSubmit={handleSubmit}>
            <h4 className="mb-2">
              <i className="feather icon-globe" style={{ marginRight: 5 }} />
              Général
            </h4>
            <div className="row">
              <div className="col-12">
                <div className="form-group has-danger">
                  <div>
                    <label htmlFor="firstName">Prénom</label>
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          id="firstName"
                          placeholder="Prénom"
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.firstName}
                        />
                        {errors.firstName && touched.firstName && (
                          <div className="mt-1 danger">{errors.firstName}</div>
                        )}
                      </>
                    ) : (
                      <p className="font-weight-bold">{user.firstName}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group has-danger">
                  <div>
                    <label htmlFor="lastName">Nom</label>
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          id="lastName"
                          placeholder="Nom"
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastName}
                        />
                        {errors.lastName && touched.lastName && (
                          <div className="mt-1 danger">{errors.lastName}</div>
                        )}
                      </>
                    ) : (
                      <p className="font-weight-bold">{user.lastName}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group has-danger">
                  <div>
                    <label htmlFor="type">Type</label>
                    {isEditing ? (
                      <>
                        <select
                          className="form-control"
                          name="type"
                          id="type"
                          value={values.type}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option value="" />
                          {Object.entries(userTypeKeyToLabel).map((value) => (
                            <option key={value[0]} value={value[0]}>
                              {value[1]}
                            </option>
                          ))}
                        </select>
                        {errors.type && touched.type && (
                          <div className="mt-1 danger">{errors.type}</div>
                        )}
                      </>
                    ) : (
                      <p className="font-weight-bold">
                        {values.type
                          ? userTypeKeyToLabel[values.type]
                          : "Pas de type défini"}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 d-flex justify-content-end">
                {isEditing ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-secondary mr-1"
                      onClick={() => setIsEditing(false)}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary ">
                      Enregistrer
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setIsEditing(true)}
                  >
                    Modifier
                    <i className="feather icon-edit-1 ml-1" />
                  </button>
                )}
              </div>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default AccountSettingForm;
